export default __webpack_public_path__ + "static/media/helen.5584f396.png";